import { ultraWideModalStyles } from '@/components/Elements/Modal/customStyles';
import { PaymentsModal } from '@/components/Elements/PaymentsModal';
import { FormContact, iFormContactFields } from '@/components/Form/FormContact';

export type FormContactInModalProps = {
  onSubmit: (values: iFormContactFields) => void;
  onRequestClose: () => void;
  isOpen: boolean;
  shouldCloseOnOverlayClick?: boolean;
  groupId: string;
  name: string;
  email?: string;
  origin: string;
  countryId: string;
  phone: string;
  product: string;
};

export const FormContactInModal = ({
  onSubmit,
  isOpen,
  onRequestClose,
  shouldCloseOnOverlayClick = true,
  groupId,
  name,
  email,
  origin,
  countryId,
  phone,
  product,
}: FormContactInModalProps) => {
  const onDefaultRequestClose = () => {
    onRequestClose();
  };
  return (
    <PaymentsModal
      isOpen={isOpen}
      style={ultraWideModalStyles}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onDefaultRequestClose}
    >
      <FormContact
        groupId={groupId}
        name={name}
        email={email}
        origin={origin}
        product={product}
        countryId={countryId}
        phone={phone}
        onSubmit={onSubmit}
        className="py-2 pl-2 pr-5 lg:px-8 lg:pb-8 lg:pt-2 overflow-y-auto max-h-[75vh]"
        showCancel={true}
        onCancelButton={onDefaultRequestClose}
      />
    </PaymentsModal>
  );
};
